import { useMutation } from '@tanstack/react-query';

import { SendLixiRequest } from '../../../../../types';
import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { postApplicationSendLixiXml } from '../../requests/postApplicationSendLixiXml';

export const useApplicationSendLixiXml = (definitionName: string) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: sendLixiXml, ...rest } = useMutation({
    mutationFn: ({ uuid, data }: { uuid: string; data: SendLixiRequest }) =>
      postApplicationSendLixiXml(constructPost, uuid, definitionName, data),
    onSuccess: () => handleSuccess('LIXI XML submitted successfully.'),
    onError: (error: ApiErrorResponse) =>
      handleError(getApiErrorMessage(error, 'Failed to send LIXI XML.')),
  });

  return { sendLixiXml, ...rest };
};
